<template>
  <main class="active-logins-page">
    <div class="active-logins-page__shell">
      <header class="active-logins-page__header">
        <div class="brand-wrapper mb-0">
          <img
            src="@/assets/images/logo.svg"
            alt="logo"
            class="logo"
          >
        </div>
        <router-link
          :to="{ name: 'choose' }"
          class="btn btn-outline-dark"
        >
          <span class="mdi mdi-arrow-left mr-1"></span>
          Aanmelden
        </router-link>
      </header>

      <section class="active-logins-page__content">
        <div class="active-logins-page__heading">
          <div>
            <p class="eyebrow mb-2">Beheer</p>
            <h1>Actieve aanmeldingen</h1>
            <p class="text-muted mb-0">Een overzicht van gebruikers die momenteel ingelogd zijn.</p>
          </div>
          <button
            type="button"
            class="btn btn-dark"
            :disabled="loading"
            @click="loadLogins"
          >
            <span class="mdi mdi-refresh mr-1"></span>
            Vernieuwen
          </button>
        </div>

        <div v-if="loading" class="active-logins-page__message text-muted">
          Aanmeldingen laden...
        </div>

        <div v-else-if="error" class="alert alert-danger" role="alert">
          {{ errorMessage }}
          <button type="button" class="btn btn-link p-0 ml-2" @click="loadLogins">
            Opnieuw proberen
          </button>
        </div>

        <div v-else-if="!logins.length" class="active-logins-page__message text-muted">
          Er zijn momenteel geen actieve aanmeldingen.
        </div>

        <div v-else class="table-responsive">
          <table class="table table-hover active-logins-page__table">
            <thead>
              <tr>
                <th scope="col">Gebruiker</th>
                <th scope="col">Device</th>
                <th scope="col">Ingelogd op</th>
                <th scope="col">Vervalt op</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="login in logins" :key="login.user_id + login.device + login.logged_in_at">
                <td>
                  <strong>{{ login.user_name || login.user_id }}</strong>
                  <small class="d-block text-muted">{{ login.user_id }}</small>
                </td>
                <td>{{ login.device || 'onbekend' }}</td>
                <td>{{ formatDate(login.logged_in_at) }}</td>
                <td>{{ formatDate(login.expires_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { getActiveLogins } from '@/api';

export default {
  name: 'ActiveLogins',
  data() {
    return {
      logins: [],
      loading: false,
      error: null,
    };
  },
  computed: {
    errorMessage() {
      if (this.error && this.error.status === 401) {
        return 'Je moet ingelogd zijn om deze pagina te bekijken.';
      }
      return 'De actieve aanmeldingen konden niet worden geladen.';
    },
  },
  mounted() {
    this.loadLogins();
  },
  methods: {
    async loadLogins() {
      this.loading = true;
      this.error = null;

      try {
        this.logins = await getActiveLogins();
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    formatDate(value) {
      if (!value) return '-';

      return new Intl.DateTimeFormat('nl-BE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(value));
    },
  },
};
</script>

<style lang="scss" scoped>
.active-logins-page {
  min-height: 100vh;
  padding: 2rem;
  background: #f4f5f3;

  &__shell {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3rem;
  }

  &__content {
    padding: 2.5rem;
    background: #fff;
    border-radius: 1rem;
    box-shadow: 0 12px 35px rgba(24, 32, 27, 0.08);
  }

  &__heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }

  &__message {
    padding: 2rem 0;
    text-align: center;
  }

  &__table {
    margin-bottom: 0;
    font-size: 0.9rem;

    th {
      white-space: nowrap;
    }
  }

  .eyebrow {
    color: #6d756e;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }

  h1 {
    margin-bottom: 0.5rem;
    color: #182019;
    font-size: 2rem;
    font-weight: 700;
  }

  @media (max-width: 767px) {
    padding: 1rem;

    &__header {
      margin-bottom: 2rem;
    }

    &__content {
      padding: 1.25rem;
    }

    &__heading {
      flex-direction: column;
    }
  }
}
</style>
